import React, {
  useEffect,
} from "react";

import HeroSection from "../components/HeroSection";
import ProductsSection from "../components/ProductsSection";
import AboutUsSection from "../components/AboutUsSection";
import WhyUsSection from "../components/WhyUsSection";
import CustomerFeedback from "../components/CustomerFeedback";
import GameRegistration from "../components/GameRegistration";

function HomePage() {

  /* ================= SCROLL TOP ================= */

  useEffect(() => {

    window.scrollTo(0, 0);

  }, []);

  /* ================= META PIXEL TRACKING ================= */

  useEffect(() => {

    if (window.fbq) {

      /* PAGE VIEW */

      window.fbq(
        "track",
        "PageView"
      );

      /* CONTENT VIEW */

      window.fbq(
        "track",
        "ViewContent",
        {
          content_name:
            "SAC MTB Homepage",

          content_category:
            "Bicycles & Ride-On Toys",

          content_type:
            "homepage",
        }
      );

      /* ENGAGEMENT TIMER */

      const timer =
        setTimeout(() => {

          window.fbq(
            "trackCustom",
            "HomepageEngagement",
            {
              page:
                "HomePage",
            }
          );

        }, 15000);

      return () =>
        clearTimeout(timer);
    }

  }, []);

  /* ================= UI ================= */

  return (

    <main className="homepage">

      {/* HERO */}
<GameRegistration/>
      <HeroSection />

      {/* PRODUCTS */}

      <ProductsSection />

      {/* ABOUT */}

      <AboutUsSection />

      {/* WHY US */}

      <WhyUsSection />

      {/* CUSTOMER STORIES */}

      <CustomerFeedback />

    </main>
  );
}

export default HomePage;